var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn",class:[_vm.styleClass, _vm.isLoading ? 'btn-loading' : ''],attrs:{"type":"submit","disabled":_vm.isDisabled || _vm.isLoading}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }